import { g as getFormatDateTimeFormatter, a as getDateOptions } from './formatDate-BIw3YDwX-BIw3YDwX.js';

const DEFAULT_DELIMITER = ' - ';
function getYearFromParts(parts) {
  var _parts$find;
  return (_parts$find = parts.find(({
    type
  }) => type === 'year')) === null || _parts$find === void 0 ? void 0 : _parts$find.value;
}
function getDateStringFromParts(parts, removeYear) {
  let internalParts = parts;
  if (removeYear) {
    // https://tiny.amazon.com/n7syqlt1/storm-playground
    const yearIndex = internalParts.findIndex(({
      type
    }) => type === 'year');
    const toBeRemovedIndex = yearIndex > 0 ? [yearIndex - 1, yearIndex] : [yearIndex, yearIndex + 1];
    internalParts = internalParts.filter((part, index) => !toBeRemovedIndex.includes(index));
  }
  return internalParts.map(({
    value
  }) => value).join('');
}

// https://code.amazon.com/packages/TropicalUI/blobs/3.0/--/packages/unified-shared-components/src/components/DateRangeFilter/utils/getDefaultLabels.ts
function formatRange(startDateParts, endDateParts) {
  const isSameYear = getYearFromParts(startDateParts) === getYearFromParts(endDateParts);
  if (isSameYear) {
    return `${getDateStringFromParts(startDateParts, true)}${DEFAULT_DELIMITER}${getDateStringFromParts(endDateParts)}`;
  }
  return `${getDateStringFromParts(startDateParts)}${DEFAULT_DELIMITER}${getDateStringFromParts(endDateParts)}`;
}

/**
 * @param {Date} startDate The start date to format.
 * @param {Date} endDate The end date to format.
 * @param {string} locale A string with a BCP 47 language tag, or an array of such strings.
 * @param {string} dateStyle The date formatting style to use. Possible values include: medium, short.
 * The default is medium.
 * @param {string} timezone The time zone to use. The default is the runtime's default time zone.
 */
function formatDateRange({
  startDate,
  endDate,
  locale,
  timezone,
  dateStyle
}) {
  const dateTimeFormatter = getFormatDateTimeFormatter(locale, getDateOptions({
    dateStyle,
    timezone
  }));
  if (!dateTimeFormatter) {
    return `${startDate.toString()}${DEFAULT_DELIMITER}${endDate.toString()}`;
  }

  // not available on old Safari
  if (typeof dateTimeFormatter.formatRange !== 'function') {
    return formatRange(dateTimeFormatter.formatToParts(startDate), dateTimeFormatter.formatToParts(endDate));
  }
  return dateTimeFormatter.formatRange(startDate, endDate);
}

export { formatDateRange as f };
//# sourceMappingURL=formatDateRange-C0bz9xvq-DOmhv8QR.js.map
